// Shared helpers for the anonymous → authenticated plan/interval handoff.
// Landing stashes `iti.selectedPlanId` + `iti.selectedInterval`; auth pages
// route to /onboarding when a selection exists; Onboarding consumes it into
// Stripe subscription checkout and clears it afterwards.
export const INTERVAL_IDS = ["monthly", "biannual", "annual"];
export const INTERVAL_LABELS = { monthly: "Monthly", biannual: "Bi-Annual", annual: "Annual" };

export function getStoredPlanSelection() {
  try {
    const planId = localStorage.getItem("iti.selectedPlanId");
    if (!planId || planId === "free") return null;
    const raw = localStorage.getItem("iti.selectedInterval");
    return { planId, interval: INTERVAL_IDS.includes(raw) ? raw : "monthly" };
  } catch {
    return null;
  }
}

export function clearPlanSelection() {
  try {
    ["iti.selectedPlanId", "iti.selectedInterval", "iti.pendingPlanId", "iti.pendingInterval"]
      .forEach((k) => localStorage.removeItem(k));
  } catch { /* ignore */ }
}

// Post-auth destination override: "/onboarding" when the user has a stashed
// website prompt or a paid plan selection waiting to be consumed, else null.
export function postAuthDestination() {
  try {
    const pendingPrompt =
      localStorage.getItem("iti.pendingPrompt") ||
      localStorage.getItem("iti.initialBusinessIdea") || "";
    if (pendingPrompt.trim()) return "/onboarding";
  } catch { /* ignore */ }
  return getStoredPlanSelection() ? "/onboarding" : null;
}
